export default __webpack_public_path__ + "static/media/linkedin.50b2df73.svg";